<template>
  <div class="view-review-results">
    <div class="review_result" v-if="!showTopicDetail">
      <!-- 筛选top -->
      <el-form ref="topicListFormRef" :model="resultParams" label-width="80px">
        <el-row>
          <el-col :span="5">
            <el-form-item label="课题名称"
              ><el-input clearable v-model="resultParams.name"></el-input
            ></el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="所属区域"
              ><el-input clearable v-model="resultParams.regionName"></el-input
            ></el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="平均分">
              <el-input
                v-model="resultParams.minScore"
                style="width: 50px"
              ></el-input>
              <span style="margin: 0 10px">~</span>
              <el-input
                v-model="resultParams.maxScore"
                style="width: 50px"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="评审结果">
              <el-select
                v-model="resultParams.appraisalResult"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in reviewResultOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" @click="search">查询</el-button>
            <el-button type="success" @click="exportExcel">导出Excel</el-button>
          </el-col>
        </el-row>
      </el-form>
      <!-- <div class="conditionLeft"></div> -->
      <el-table
        id="table"
        :header-cell-style="tableStyle"
        border
        ref="multipleTable"
        :data="resultList"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
        ></el-table-column>
        <!-- <el-table-column type="index" label="编号" width="50" align="center"></el-table-column> -->
        <el-table-column prop="declareName" label="课题名称" align="center">
          <template v-slot="scope">
            <span
              style="color: #006dcc; cursor: pointer"
              @click="goTopicReviewDetail(scope.row)"
              >{{ scope.row.declareName }}</span
            >
          </template>
        </el-table-column>
        <!-- <el-table-column prop="projectLevelName" label="课题级别" align="center"></el-table-column> -->
        <el-table-column
          prop="projectTypeName"
          label="课题类别"
          align="center"
        ></el-table-column>
        <!-- <el-table-column prop="regionName" label="所属区域" align="center"></el-table-column> -->
        <el-table-column
          prop="unitName"
          label="单位"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="oneEmceeName"
          label="负责人姓名"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="groupName"
          label="评审组"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="avgScore"
          label="平均分"
          sortable
          align="center"
        ></el-table-column>
        <!-- <el-table-column prop="type" :label="$route.query.reviewType == 0 ? '是否晋级到复评' : '是否晋级到终评'" align="center">
					<template slot-scope="scope">
						{{ getState(scope.row.type) }}
					</template>
				</el-table-column> -->
        <el-table-column
          prop="typeName"
          label="评审结果"
          sortable
          align="center"
        ></el-table-column>
        <el-table-column label="评语" align="center">
          <template v-slot="scope">
            <el-button type="primary" @click="openRemarkDialog(scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
     <el-pagination   :total="total"  style="margin-top:20px"
	   :page-size='resultParams.pageSize' :current-page="resultParams.pageNumber"        layout="total, sizes, prev, pager, next, jumper"      :page-sizes="[10,20,30,35]"   @size-change="changepages"  @current-change="changesize"     >
      </el-pagination>
   

      <div style="margin-top: 20px">
        <button
          type="button"
          v-if="$route.query.reviewType != 3"
          class="btn btn-info"
          style="margin-right: 20px"
          @click="promotion"
        >
          {{
            $route.query.reviewType == 0
              ? "晋级到复评"
              : $route.query.reviewType == 1
              ? "晋级到终评"
              : ""
          }}
        </button>
        <button type="button" class="btn btn-info" @click="submitResult">
          提交评审结果
        </button>
      </div>
    
      <!-- 评语列表窗口 -->
      <el-dialog
        title="提示"
        :visible.sync="remarkDialogVisible"
        width="60%"
        :before-close="handleClose"
      >
        <ul class="remark_list">
          <li class="remark_item" v-for="item in remarkList" :key="item.id">
            <span>{{ item.userName + "：" }}</span>
            <!-- <span>{{ item.note ? item.note : '还没有评语' }}</span> -->
            <span>{{ item.note }}</span>
          </li>
        </ul>
        <span slot="footer" class="dialog-footer">
          <el-button @click="remarkDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="remarkDialogVisible = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <!-- 当前课题专家评审详情 -->
    <div class="topic_detail" v-if="curTopicInfo && showTopicDetail">
      <h3 class="text-center">{{ curTopicInfo.reportName }}</h3>
      <div class="row row-reviewDetails">
        <div class="col-6 col-md-3">
          负责人姓名：{{ curTopicInfo.oneEmceeName }}
        </div>
        <div class="col-6 col-md-3">
          申报单位：{{ curTopicInfo.oneUnitName }}
        </div>
        <div class="col-6 col-md-3">
          学段：{{ curTopicInfo.learningTypeName }}
        </div>
        <div class="col-6 col-md-3">
          学科：{{ curTopicInfo.disciplineName }}
        </div>
        <div class="col-6 col-md-3">
          预结题时间：{{ curTopicInfo.expectedClosingTime | getTime }}
        </div>
        <div class="col-6 col-md-3">
          领域：{{ curTopicInfo.researchFieName }}
        </div>
      </div>
      <!-- 审核文件列表 -->
      <!-- <ul class="file-list">
				<li class="file-item" :class="{ active: curFileTitleIndex === index }" v-for="(item, index) in fileTitleList" :key="index" @click="changeFileTitle(index)">{{ item }}</li>
			</ul> -->

      <!-- 在线开题报告 -->
      <!-- <div class="view" v-show="curFileTitleIndex == 0"><iframe ref="myIframe" height="100%" width="100%"></iframe></div> -->
      <div class="view">
        <iframe ref="myIframe" height="100%" width="100%"></iframe>
      </div>

      <!-- 在线文档列表 -->
      <!-- <div class="view_report" v-show="curFileTitleIndex == 1"> -->
      <div class="view_report">
        <!-- <div class="single_file" v-if="curTopicInfo.annexList && curTopicInfo.annexList.length == 1 && curTopicInfo.annexList[0].fileType !== 'other'">
					<iframe ref="myIframe1" height="100%" width="100%"></iframe>
				</div> -->
        <h4>相关资料列表</h4>
        <div
          class="file_list"
          v-if="curTopicInfo.annexList && curTopicInfo.annexList.length > 0"
        >
          <!-- <div class="file_list_title">相关资料列表</div> -->
          <div
            class="file_item"
            v-for="item in curTopicInfo.annexList"
            :key="item.id"
            @click="preview(item)"
          >
            <div class="file_type">{{ item.fileType | formatFileType }}</div>
            <div class="file_name">{{ item.annexName }}</div>
          </div>
        </div>

        <div class="no_file" v-else>没有相关文件</div>
      </div>

      <div class="table_wrap">
        <div class="table_title">专家评分详情</div>
        <el-table
          :header-cell-style="tableStyle"
          :data="remarkList"
          border
          style="width: 100%; margin-bottom: 10px"
        >
          <el-table-column
            prop="userName"
            label="姓名"
            width="180"
          ></el-table-column>
          <el-table-column prop="score" label="评分" width="60">
            <template v-slot="scope">
              {{ scope.row.score }}
            </template>
          </el-table-column>
          <el-table-column prop="typeName" label="评审结果" width="100">
            <template v-slot="scope">
              {{ scope.row.typeName }}
            </template>
          </el-table-column>
          <el-table-column prop="note" label="评语">
            <template v-slot="scope">
              {{ scope.row.note }}
            </template>
          </el-table-column>
        </el-table>

        <div class="review_stat">
          <span style="margin-right: 20px"
            >最终平均分：{{ curTopicInfo.avgScore }}</span
          >
          <span>评审表决结果：{{ curTopicInfo.result }}</span>
        </div>

        <div class="btn_wrap">
          <el-button type="primary" @click="showTopicDetail = false"
            >返回</el-button
          >
        </div>
      </div>
    </div>
    <el-dialog
      title="视频预览"
      :visible.sync="filePreviewDialogVisible"
      width="50%"
      :before-close="closePreviewFileDialog"
    >
      <div class="preview_wrap">
        <video
          ref="previewVideo"
          style="width: 500px; height: 400px"
          autoplay
          controls
          :src="curPreviewFileUrl"
        ></video>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closePreviewFileDialog">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import { getReviewResult, topicPromotion, submitReviewResult,getReviewBaseInfoById } from '@/api/after/expertReviewSettings.js';
import {
  getReviewResult,
  getBaseInfoDetail,
  promotionFunction,
  submitReviewResult,
  getRemarkListById,
} from "@/api/after/topicManage.js";
import { getPlatformInformationData } from "@/api/after/systemManagement";
import { expertReviewResultList } from "@/api/after/topicManage.js";
import FileSaver from "file-saver";
import XLSX from "xlsx";
export default {
  data() {
    return {
		total:0,
      curPreviewFileUrl: "", //视频附件url
      filePreviewDialogVisible: false, //附件预览弹框
      tableStyle: {
        backgroundColor: "#7e9be2",
        color: "#fff",
        textAlign: "center",
      },
      reviewResultOptions: [], //获取维护评审结果信息
      options: [],
      resultList: [], //结果列表
      resultTotal: 0,
      resultParams: {
        appraisalResult: null,
        maxScore: null,
        minScore: null,
        name: "",
        pageNumber: 1,
        pageSize: 10,
        regionName: "",
        regionId: "", //区域id
        settingId: "", //设置id
      },
      multipleVal: [],
      reviewBaseInfo: null,
      remarkDialogVisible: false, //评语列表窗口
      remarkList: [],
      curTopicInfo: null, //当前课题信息
      curFileTitleIndex: 0,
      fileTitleList: ["报告", "相关材料"],
      showTopicDetail: false, //展示课题详情
    };
  },
  computed: {
    getState(val) {
      return (val) => {
        if (val) {
          if (this.reviewBaseInfo) {
            if (this.reviewBaseInfo.reviewType == 0) {
              //初评阶段
              if ([7, 8, 9, 10, 11].includes(val)) {
                return "未晋级";
              } else {
                return "已晋级";
              }
            } else if (this.reviewBaseInfo.reviewType == 1) {
              //抚平阶段
              if ([12, 13, 14, 15, 16].includes(val)) {
                return "未晋级";
              } else {
                return "已晋级";
              }
            }
          }
        } else {
          return "";
        }
      };
    },
    // 获取评审结果
    // calcReviewResult(val){
    // 	return val=>{
    // 		if (val) {
    // 			if (val.avgScore) {
    // 				if (val.appraisalResult == 1) {
    // 					return '建议'
    // 				}else if (val.appraisalResult === null) {
    // 					return '无结果'
    // 				}else if (val.appraisalResult == 0) {
    // 					return '不建议'
    // 				}
    // 			}else{
    // 				return '未评'
    // 			}
    // 		}
    // 	}
    // }
  },
  filters: {
    formatFileType(val) {
      switch (val) {
        case "pic":
          return "图片";
          break;
        case "doc":
          return "文档";
          break;
        case "docx":
          return "文档";
          break;
        case "video":
          return "视频";
          break;
        case "other":
          return "其他文件";
          break;
        default:
      }
    },
  },
  created() {
    this.getBaseInfoDetail();
    this.getReviewResultOptions();
    this.getReviewResult();
  },
  methods: {
     //更改页数
    changesize(e){

     this.resultParams.pageNumber=e
     this.getReviewResult()


	},
          //更改条数
     changepages(e){
     this.resultParams.pageSize=e

     this.getReviewResult()
	 },
    changeFileTitle(index) {
      if (index == 0) {
        this.curFileTitleIndex = index;
        this.$refs.myIframe.contentWindow.location.replace(
          `${this.uploadUrl}/upload/downloadPdf/${this.curTopicInfo.annex}`
        );
      } else {
        if (
          this.curTopicInfo.annexList &&
          this.curTopicInfo.annexList.length == 1
        ) {
          let fileObj = this.curTopicInfo.annexList[0];
          if (fileObj.fileType == "doc" || fileObj.fileType == "docx") {
            this.$refs.myIframe1.contentWindow.location.replace(
              `${this.uploadUrl}/upload/downloadPdf/${fileObj.id}`
            );
          } else if (fileObj.fileType == "video") {
            this.$refs.myIframe1.contentWindow.location.replace(
              `${this.uploadUrl}/upload/previewVideo/${fileObj.id}`
            );
          } else if (fileObj.fileType == "pic") {
            window.open(
              `${this.uploadUrl}/upload/previewImage/${fileObj.id}`,
              "_blank"
            );
          } else {
            window.open(
              `${this.uploadUrl}/upload/download?id=${fileObj.id}&openStyle=1`,
              "_blank"
            );
          }
        } else {
          this.curFileTitleIndex = index;
        }
      }
    },
    // 关闭文件预览对话框
    closePreviewFileDialog() {
      this.filePreviewDialogVisible = false;
      this.$refs.previewVideo.pause();
    },
    // 打开预览文件对话框
    preview(item) {
      if (item.fileType == "doc" || item.fileType == "docx") {
        window.open(
          `${this.uploadUrl}/upload/downloadPdf/${item.id}`,
          "_blank"
        );
      } else if (item.fileType == "video") {
        // window.open(`${this.uploadUrl}/upload/previewVideo/${item.id}`, '_blank');
        this.curPreviewFileUrl = `${this.uploadUrl}/upload/previewVideo/${item.id}`;
        this.filePreviewDialogVisible = true;
      } else if (item.fileType == "pic") {
        window.open(
          `${this.uploadUrl}/upload/previewImage/${item.id}`,
          "_blank"
        );
      } else {
        window.open(
          `${this.uploadUrl}/upload/download?id=${item.id}&openStyle=1`,
          "_blank"
        );
      }
    },
    // 跳转到课题详情
    goTopicReviewDetail(item) {
      this.showTopicDetail = true;
      this.getRemarkListById(item);
    },
    // 根据评审ID获取评审基本信息
    async getBaseInfoDetail() {
      const res = await getBaseInfoDetail(this.$route.query.reviewId);
      if (res.code == 200) {
        this.reviewBaseInfo = res.data;
        switch (this.reviewBaseInfo.reviewType) {
          case 0:
            this.fileTitleList[0] = "开题报告";
            break;
          case 1:
            this.fileTitleList[0] = "中期报告";
            break;
          case 2:
            this.fileTitleList[0] = "结题申请报告";
            break;
          case 3:
            this.fileTitleList[0] = "结题报告";
            break;
          default:
            break;
        }
      } else {
        this.$message.error(res.data);
      }
    },
    search() {
      this.resultParams.pageNumber = 1;
      this.getReviewResult();
    },
    // 导出Excel列表
    async exportExcel() {
      let settingId = this.$route.query.reviewId;
      const res = await expertReviewResultList(settingId);
      console.log("导出excel", res);
      //创建一个a标签并实现下载功能
      const link = document.createElement("a");
      let blob = new Blob([res], { type: "application/octet-stream" }); //res是文件流
      link.style.display = "none";
      link.href = URL.createObjectURL(blob);
      link.download = "评审结果.xls"; //下载的文件名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      // if () {
      //
      // }
      // var xlsxParam = { raw: true };
      // var wb = XLSX.utils.table_to_book(document.querySelector('#table'), xlsxParam);
      // var wbout = XLSX.write(wb, {
      // 	bookType: 'xlsx',
      // 	bookSST: true,
      // 	type: 'array'
      // });
      // try {
      // 	FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '评审结果.xlsx');
      // } catch (e) {
      // 	if (typeof console !== 'undefined') {
      // 		console.log(e, wbout);
      // 	}
      // }
      // return wbout;
    },
    // 表格多选
    handleSelectionChange(val) {
      console.log("多选", val);
      this.multipleVal = val;
    },
    // 获取评审结果
    async getReviewResult() {

      this.resultParams.settingId = +this.$route.query.reviewId;
      const res = await getReviewResult(this.resultParams);
      if (res.code == 200) {
        this.resultList=[]
        this.resultList = res.data.records;
        this.total = res.data.total;

      } else {
        this.$message.error(res.data);
      }
    },
    // 晋级
    promotion() {
      this.$confirm("确定要将选择的课题晋级吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            ids: [],
            reviewType: +this.reviewBaseInfo.reviewType + 1,
          };
          if (this.multipleVal.length === 0) {
            this.$message.error("请选择要晋级的课题！");
            return;
          }
          params.ids = this.multipleVal.map((item) => {
            return item.id;
          });
          console.log("晋级参数", params);
          this.promotionFunction(params);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 课题晋级接口
    async promotionFunction(data) {
      const res = await promotionFunction(data);
      if (res.code == 200) {
        this.$message.success("晋级成功！");
        this.getReviewResult();
      } else {
        this.$message.error(res.data);
      }
    },
    // 提交评审结果
    submitResult() {
      this.$confirm(
        "确定要结束本次评审活动吗？结束后所有信息不允许再修改!",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          let ids = this.resultList.map((item) => {
            return item.id;
          });
          let params = {
            settingId: this.$route.query.reviewId,
            ids,
          };
          console.log("提交评审结果", params);
          this.submitReviewResult(params);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 提交评审结果接口
    async submitReviewResult(data) {
      const res = await submitReviewResult(data);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "提交评审结果成功！",
          duration: 1000,
          onclose: () => {
            this.$router.go(-1);
          },
        });
      } else {
        this.$message.error(res.data);
      }
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    // 打开评语对话框
    openRemarkDialog(item) {
      console.log("asddsa");
      this.remarkDialogVisible = true;
      this.getRemarkListById(item);
    },
    // 获取评语请求
    async getRemarkListById(item) {
      let params = {
        settingId: item.settingId,
        projectManagementId: item.id,
      };
      const res = await getRemarkListById(params);
      if (res.code == 200) {
        console.log("评语列表", res);
        this.remarkList = res.data.scoreList;
        // 如果当前是在查看课题详情
        if (this.showTopicDetail) {
          this.curTopicInfo = res.data;
          // // 数据请求成功之后渲染pdf
          if (Object.keys(this.curTopicInfo).length) {
            // 等待v-if渲染的页面渲染成功后拿到iframe
            this.$nextTick(() => {
              this.$refs.myIframe.contentWindow.location.replace(
                `${this.uploadUrl}/upload/downloadPdf/${this.curTopicInfo.annex}`
              );
            });
          }
        }
      } else {
        this.$message.error(res.data);
      }
    },
    // 获取评审结果数据
    async getReviewResultOptions() {
      const res = await getPlatformInformationData(10);
      if (res.code == 200) {
        console.log("评审结果信息", res);
        this.reviewResultOptions = res.data;
      } else {
        this.$message.error(res.data);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.preview_wrap {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.view_report {
  margin-top: 50px;
}
.table_wrap {
  margin-top: 20px;
  .table_title {
    font-size: 18px;
    font-weight: bolder;
    margin-bottom: 10px;
  }
}
.btn_wrap {
  text-align: center;
}
.review_stat {
  margin-bottom: 10px;
}
.remark_list {
  list-style: none;
  padding-left: 0px;
  .remark_item {
  }
}
.view {
  width: 1000px;
  height: 500px;
  margin: 0 auto;
}
.file-list {
  width: 100%;
  display: flex;
  justify-content: center;
  padding-left: 0;
  list-style: none;
  .file-item {
    font-size: 24px;
    text-align: center;
    width: 50%;
    border-bottom: 2px solid #eee;
    cursor: pointer;
  }
}
.file-item.active {
  border-color: #00a2e8;
}
.file_list {
  border-bottom: 1px solid #ccc;
  .file_list_title {
    font-size: 18px;
    font-weight: bolder;
    margin-bottom: 15px;
  }
  .file_item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    cursor: pointer;
    .file_type {
      font-size: 18px;
      font-weight: bolder;
      margin-right: 20px;
    }
  }
  .file_item:hover {
    color: #006dcc;
  }
}
</style>
